let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("41TKw")).then(() => parcelRequire('4cmmO'));